import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function updateUserEmail(userId, email, contractId, ownerType) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      UserId: userId,
      EmailAddress: email,
      ContractId: contractId,
      OwnerType: ownerType,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/email",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
